export const DEFAULT_MONITOR_DEVICE_TYPE = '市电远传'
export const CUSTOM_DATA_TYPE = '自定义类型'

const CITY_POWER_TYPE = '市电远传'
const LOW_POWER_TYPE = '低功耗远传'
const PRESSURE_TYPE = '压力远传'

export const DEVICE_TYPE_METRICS = {
  [CUSTOM_DATA_TYPE]: [],
  [CITY_POWER_TYPE]: [
    { key: 'stdTotal', label: '标况总量', unit: 'Nm³', width: 130 },
    { key: 'workTotal', label: '工况总量', unit: 'm³', width: 130 },
    { key: 'temperature', label: '温度', unit: '℃', width: 110 },
    { key: 'pressure', label: '压力', unit: 'Kpa', width: 110 },
    { key: 'stdInstant', label: '标况瞬时', unit: 'Nm³/h', width: 140 },
    { key: 'workInstant', label: '工况瞬时', unit: 'm³/h', width: 140 }
  ],
  [PRESSURE_TYPE]: [
    { key: 'leakage', label: '泄漏浓度', unit: '%LEL', width: 130 },
    { key: 'inletPressure', label: '进口压力', unit: 'kPa', width: 130 },
    { key: 'outletPressure', label: '出口压力1', unit: 'kPa', width: 130 },
    { key: 'outletPressure2', label: '出口压力2', unit: 'kPa', width: 130 },
    { key: 'outletPressure3', label: '出口压力3', unit: 'kPa', width: 130 },
    { key: 'diffPressure1', label: '差压1', unit: 'kPa', width: 120 },
    { key: 'diffPressure2', label: '差压2', unit: 'kPa', width: 120 }
  ],
  [LOW_POWER_TYPE]: [
    { key: 'stdTotal', label: '标况总量', unit: 'Nm³', width: 130 },
    { key: 'workTotal', label: '工况总量', unit: 'm³', width: 130 },
    { key: 'temperature', label: '温度', unit: '℃', width: 110 },
    { key: 'pressure', label: '压力', unit: 'Kpa', width: 110 },
    { key: 'stdInstant', label: '标况瞬时', unit: 'Nm³/h', width: 140 },
    { key: 'workInstant', label: '工况瞬时', unit: 'm³/h', width: 140 },
    { key: 'signalStrength', label: '信号强度', unit: 'dBm', width: 120 },
    { key: 'batteryLevel', label: '电池电量', unit: '%', width: 120 }
  ]
}

export function isCustomDataType(type) {
  return String(type || '').includes('自定义')
}

export function normalizeDeviceType(type) {
  const text = String(type || '').trim()
  const lower = text.toLowerCase()
  if (isCustomDataType(text)) return CUSTOM_DATA_TYPE
  if (text.includes('低功耗') || lower.includes('battery') || lower.includes('low')) return LOW_POWER_TYPE
  if (text.includes('压力') || text.includes('调压') || lower.includes('pressure')) return PRESSURE_TYPE
  if (text.includes('市电') || text.includes('透传') || lower.includes('city') || lower.includes('passthrough')) return CITY_POWER_TYPE
  return DEFAULT_MONITOR_DEVICE_TYPE
}

export function getDeviceTypeMetrics(type) {
  const normalized = normalizeDeviceType(type)
  if (normalized === CUSTOM_DATA_TYPE) return []
  return DEVICE_TYPE_METRICS[normalized] || DEVICE_TYPE_METRICS[DEFAULT_MONITOR_DEVICE_TYPE]
}

export function allDeviceMetrics() {
  const seen = new Set()
  return Object.values(DEVICE_TYPE_METRICS).flat().filter(item => {
    if (seen.has(item.key)) return false
    seen.add(item.key)
    return true
  })
}

export function deviceMetricByKey(key) {
  return allDeviceMetrics().find(item => item.key === key) || null
}

export function formatMetricColumnLabel(metric) {
  if (!metric) return ''
  return metric.unit ? `${metric.label}(${metric.unit})` : metric.label
}

export function metricValueFromRow(row, metric) {
  if (!row || !metric) return null
  if (metric.key === 'outletPressure') {
    return row.outletPressure != null ? row.outletPressure : row.pressure
  }
  if (metric.key === 'leakage') {
    if (row.leakage != null) return row.leakage
    if (row.inletLeak != null) return row.inletLeak
    return row.concentration
  }
  if (row[metric.key] != null && row[metric.key] !== '') return row[metric.key]
  const extra = row.extraMetrics
  if (extra && extra[metric.key] != null && extra[metric.key] !== '') return extra[metric.key]
  const aliases = {
    stdTotal: ['stdTotalSum'],
    workTotal: ['workTotalSum'],
    stdInstant: ['stdInstantAvg'],
    workInstant: ['workInstantAvg'],
    pressure: ['pressureAvg'],
    temperature: ['temperatureAvg'],
    inletPressure: ['inletPressureAvg'],
    outletPressure: ['outletPressureAvg'],
    leakage: ['leakageAvg'],
    signalStrength: ['signalStrengthAvg'],
    batteryLevel: ['batteryLevelAvg']
  }
  const list = aliases[metric.key] || []
  for (let i = 0; i < list.length; i++) {
    const key = list[i]
    if (row[key] != null && row[key] !== '') return row[key]
  }
  return null
}

const PRESSURE_METRIC_KEYS = new Set([
  'pressure', 'inletPressure', 'outletPressure', 'outletPressure2', 'outletPressure3',
  'diffPressure1', 'diffPressure2'
])

export function monitorMetricMaxDecimals(metric) {
  const key = typeof metric === 'string' ? metric : (metric && metric.key)
  return PRESSURE_METRIC_KEYS.has(key) ? 3 : 2
}

export function formatMonitorMetricValue(value, metric) {
  if (value == null || value === '') return '—'
  const n = Number(value)
  if (!Number.isFinite(n)) return String(value)
  const fixed = n.toFixed(monitorMetricMaxDecimals(metric))
  if (!fixed.includes('.')) return fixed
  return fixed.replace(/0+$/, '').replace(/\.$/, '')
}
